import { render, staticRenderFns } from "./AppDistributors.vue?vue&type=template&id=04aaef48&"
import script from "./AppDistributors.vue?vue&type=script&lang=js&"
export * from "./AppDistributors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports